import axios from 'axios'

export default class RegisterService {


    async register(data) {
        const {username, name, surname, email, password, refid, phone, address, zip, city, country, sponsor, captchaToken} = data

        try {
            const res = await axios({
                method: 'post',
                url: process.env.VUE_APP_AUTH_URL + 'api/auth/register',
                data: {
                    username: username, 
                    name: name, 
                    surname : surname,
                    email: email,
                    password: password, 
                    refid: refid,
                    phone: phone,
                    address: address,
                    zip: zip,
                    city: city,
                    country: country, 
                    sponsor: sponsor, 
                    captchaToken: captchaToken
                }
            })
            // console.log('res je ')
            // console.log(res.status)
            return res
            
        } catch(error) {
            if (error.response) {                
            //   console.log(error.response.status);
            //   console.log(error.response.headers);
              return error.response //throw new error - refactor
            }
           
            return 0;
          }

        
    }

    async registerCompany(data) {
        //TODO: reduce number of params to 1
        const { company_name, email, password, company, refid } = data

        try {
            const res = await axios({
                method: 'post',
                url: process.env.VUE_APP_AUTH_URL + 'api/auth/register',
                data: {
                    name: 'Company:',
                    surname: company_name,
                    username: company_name,
                    company_name: company_name,
                    email: email,
                    password: password,
                    company: company,
                    refid: refid,
                    user_id: refid,
                }
            })
            console.log('res je ')
            console.log(res.status)
            return res

        } catch (error) {
            if (error.response) {
                console.log(error.response.status);
                console.log(error.response.headers);
                return error.response //throw new error - refactor
            }

            return 0;
        }


    }

    async getSponsor(id) {
        try {
            const res = await axios({
                method: 'get',
                url: process.env.VUE_APP_AUTH_URL + 'api/auth/register/sponsor/' + id,

            });
            return res.data.username
            
        } catch (error) {
            throw new Error(error)
        }
       
    }

    async resendRegistrationMail(mail) {
        try {
            const res = await axios({
                method: 'post',
                url: process.env.VUE_APP_AUTH_URL + 'api/auth/register/resendmail',
                data: {email: mail}

            });
            return res
            
        } catch (error) {
            throw new Error(error)
        }
       
    }
}